import { Button, ButtonExtendedProps, Text } from 'grommet';
import { Add } from 'grommet-icons';

export interface IAddNewButtonProps extends ButtonExtendedProps {
  onClick: (e?: React.MouseEvent) => void;
  /** What it adds, shown on the button: "Add role", "New estimate" */
  label?: string;
  pad?: string;
  margin?: string;
  /** A longer description, shown as a tooltip; also the label when there's no `label` */
  tipText?: string;
}

/**
 * "+ Add role": a labelled add button, filled brand by default. Pass `secondary` (outlined) or
 * `plain` where a filled button would be too loud, e.g. a row's footer.
 */
export const AddNewButton = ({ onClick, label, tipText, ...rest }: IAddNewButtonProps) => {
  const text = label ?? tipText;
  const tip = tipText && tipText !== text ? tipText : undefined;

  return (
    <Button
      primary={!rest.secondary && !rest.plain}
      size="small"
      onClick={() => onClick()}
      // A plain one is a text link in the brand color, e.g. "+ Add activity" under a table
      icon={<Add size="14px" color={rest.plain ? 'brand' : undefined} />}
      gap="xsmall"
      label={
        <Text size="small" weight={600} color={rest.plain ? 'brand' : undefined}>
          {text}
        </Text>
      }
      style={{ padding: '5px 14px', borderRadius: '18px', whiteSpace: 'nowrap', flexShrink: 0 }}
      {...rest}
      tip={
        tip
          ? {
            content: tip,
            dropProps: {
              background: 'light-2',
              round: 'small',
              pad: 'small',
              margin: 'small',
              border: 'all',
            },
            plain: true,
          }
          : undefined
      }
    />
  );
};
